import styled from 'styled-components';

export const PageContainer = styled.div`
  position: fixed;
  width: ${({ theme }) => theme.width.full};
  align-items: center;
  height: 100%;
  text-align: center;
  padding-top: 65%;
  background-color: ${({ theme }) => theme.colors.verdigrisDark};
`;

export const HeaderContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing.xm};
`;

export const TextContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.xm};
  margin-bottom: ${({ theme }) => theme.spacing.xm};
`;

export const ContinueContainer = styled.div`
  text-align: center;
  text-decoration-line: underline;
  margin-top: 100px;
  margin-bottom: ${({ theme }) => theme.spacing.xm};
  text-decoration-color: ${({ theme }) => theme.colors.white};
`;

export const TickPointsIcon = styled.span`
  svg {
    fill: white;
  }
`;
